/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllSourceTags200ResponseDataInner } from './FindAllSourceTags200ResponseDataInner';
import {
    FindAllSourceTags200ResponseDataInnerFromJSON,
    FindAllSourceTags200ResponseDataInnerFromJSONTyped,
    FindAllSourceTags200ResponseDataInnerToJSON,
    FindAllSourceTags200ResponseDataInnerToJSONTyped,
} from './FindAllSourceTags200ResponseDataInner';

/**
 * 
 * @export
 * @interface FindAllSourceTags200Response
 */
export interface FindAllSourceTags200Response {
    /**
     * 
     */
    data?: Array<FindAllSourceTags200ResponseDataInner>;
}

/**
 * Check if a given object implements the FindAllSourceTags200Response interface.
 */
export function instanceOfFindAllSourceTags200Response(value: object): value is FindAllSourceTags200Response {
    return true;
}

export function FindAllSourceTags200ResponseFromJSON(json: any): FindAllSourceTags200Response {
    return FindAllSourceTags200ResponseFromJSONTyped(json, false);
}

export function FindAllSourceTags200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllSourceTags200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(FindAllSourceTags200ResponseDataInnerFromJSON)),
    };
}

export function FindAllSourceTags200ResponseToJSON(json: any): FindAllSourceTags200Response {
    return FindAllSourceTags200ResponseToJSONTyped(json, false);
}

export function FindAllSourceTags200ResponseToJSONTyped(value?: FindAllSourceTags200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(FindAllSourceTags200ResponseDataInnerToJSON)),
    };
}

